<template>
    <div>
        <div class="page-main">
            <div class='product'>
                <div class='productWrap' v-for='(item, index) in productList' :key = 'index' @click='productDetail(item)'>
                    <img :src="JSON.parse(item.coverUrl).m" alt="" class='productimg'>
                    <p class='productName'>{{item.productName.length > 13 ? item.productName.substring(0, 10) + '...': item.productName}}</p>
                    <div class='saleNumber'>
                        <p class='number'>￥ <span class='price'>{{item.price / 100 || 0}}</span></p>
                        <p class='sale'>{{item.orderTotal || 0}}人购买</p>
                    </div>
                </div>
            </div>
            <!-- 二维码弹框 -->
            <div class='erweicodetip' v-if='isShow'>
                <div class='showerwei'>
                    <img :src="qrCodeurl" v-if='qrCodeurl' class='erweicodestyle' alt="">
                    <p class='chanan'>长按识别小程序购买</p>
                    <div class="sure" @click='close'>
                        <p>关闭</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import services from './services';

export default {
    data() {
        return {
            productList: [],
            isShow: false,
            qrCodeurl: ''
        };
    },
    mounted() {
        this.getData();
    },
    methods: {
        productDetail(data) {
            const paramsa = {
                accessToken: '32_lxuHujPIottb20swkxuWLWN0HO_IiYUJDz9sfYRKQyQWjYY2MVqlGFHnzkYirLi4wmaDQ9MRpduTpxGXKKxiMgomLELVzifo4XrVg875xdxVCHcY6fmtTctND9PcaWos2HyhixM62CGZB0WTLHUeAAAWSF',
                scene: `productList,${data.id},0`,
                // scene: `productList,1000197,0`,

                page: 'pages/active/activeProductDetails/main', // 跳转页面
                width: 280,
                isHyaline: false,//false
            };
            services.getQrcode(paramsa).then(res => {
                this.qrCodeurl = `data:image/jpeg;base64,${res.data.buffer}`;
                // console.log(this.qrCodeurl);
                this.isShow = true;
            });
        },
        getData() {
            const params = {
                id: this.$route.params.id,
                pageSize: 20,
                pageIndex: 1,
            };
            services.getList(params).then(res => {
                this.productList = res.data.list || [];
            });
        },
        close() {
            this.isShow = false;
        }
    }
};
</script>

<style lang='stylus' scoped>
.page-main
    width 100%
    background-color #e5e5e5
    .product
        width 100%
        padding 2% 2%
        display flex
        flex-direction row
        flex-wrap wrap
        justify-content space-between
        .productWrap
            width 3.46rem
            height 5.31rem
            border-radius 0.1rem
            background-color #fff
            margin-bottom 0.2rem
            display flex
            flex-direction column
            align-items center
            position relative
            .productimg
                width 3.46rem
                height 3.47rem
                margin-bottom .24rem
            .productName
                display block
                width 2.88rem
                font-size .24rem
                line-height .36rem
                text-align justify
            .saleNumber
                width 100%
                height .30rem
                display flex
                flex-direction row
                justify-content space-around
                align-items center
                margin-top 0.45rem
                .number
                    color #ff4444
                    font-size .20rem
                    margin-left -0.40rem
                    .price
                        font-size .32rem
                .sale
                    font-size .18rem
                    color #999999
                    margin-right -0.3rem
    .erweicodetip
        width 100%
        height 100%
        position fixed
        top 0
        left 0
        bottom 0
        right 0
        display flex
        flex-direction row
        align-items center
        justify-content center
        background-color rgba(0, 0, 0, 0.7)
        z-index 6666
        .showerwei
            width 70%
            height 44%
            z-index 1000
            background-color #fff
            position relative
            .erweicodestyle
                position absolute
                left 50%
                transform translateX(-50%)
                top 10%
            .chanan
                width 100%
                text-align center
                font-size 0.28rem
                color #5c5c5c
                position absolute
                left 50%
                transform translateX(-50%)
                bottom 20%
            .sure
                width 100%
                height 17%
                position absolute
                display flex
                flex-direction row
                align-items center
                justify-content center
                bottom 0
                border-top 1px solid #eeeeee
                p
                    font-size 0.36rem
                    color #959494
</style>
